import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import Utils from "./../../utils/utils.js";
import NavButton from "./nav/NavButton";
import NavPane from "./nav/NavPane";
import NavAction from "./nav/NavAction";
import NavModal from "./nav/NavModal";
import LoadHTMLModal from './nav/modals/LoadHTMLModal'

@observer
class TopNav extends Component {
  @observable links = {};
  @observable modals = {};

  componentDidMount() {
    const zr = this.refs.zoomify;
    if (zr) {
      zr.onclick = this.showZooms.bind(this);
      window.onclick = this.hideZooms.bind(this);
    }

    this.addModal({
      "load-html": (
        <LoadHTMLModal onValidate={(modal) => {
          let html = modal.getHTML();
          html = this.validateHTML(html);
          if(!html) {
            console.log('error: wrong html!');
          } else {
            this.getDocument().loadElementsFromHTML(html);
            modal.getChild(0).value = "";
          }
        }}
      onCancel={(modal) => {
        modal.getChild(0).value = "";
      }}/>
      )
    })
  }

  validateHTML(html) {
    const p = new DOMParser();
    try {
      p.parseFromString(html, 'text/html');
      html = html.replace(/\n+/g, '');
      html = html.replace(/\s{2,}/g, '');
      return html.trim();
    } catch(e) {
      return false;
    }
  }

  getDocument() {
    return this.links ? this.links.container.getChild(0) : null;
  }

  addModal(modal) {
    this.modals = {...this.modals, ...modal};
  }

  hideZooms(e) {
    e.preventDefault();
    e.stopPropagation();
    const zooms = this.refs.zooms;
    zooms.style.visibility = "hidden";
  }

  showZooms(e) {
    e.preventDefault();
    e.stopPropagation();
    const zooms = this.refs.zooms;
    zooms.style.visibility = "visible";
  }

  setLinks(links) {
    this.links = links;
  }

  getZoomPercentage() {
    if (!this.links.container) return;
    return Math.floor(100 * this.links.container.zoom * 100) / 100;
  }

  setZoom(zoom) {
    if (!this.links.container) return;
    this.links.container.zoomToCenter(zoom);
  }

  zoomAction(action) {
    if (action.toLowerCase() === "zoom in") {
      this.links.container.zoomInToCenter();
    } else if (action.toLowerCase() === "zoom out") {
      this.links.container.zoomOutFromCenter();
    } else {
      this.links.container.defaultZoom();
    }
  }

  getAllZooms() {
    return [
      33,
      50,
      75,
      100,
      150,
      200,
      "Zoom In",
      "Zoom Out",
      "Global Zoom"
    ].map((zoom, index) => {
      if (typeof zoom === "number")
        return (
          <span key={index} onClick={() => this.setZoom(zoom / 100)}>
            {zoom + "%"}
          </span>
        );
      else
        return (
          <div
            key={index}
            className="action"
            onClick={() => this.zoomAction(zoom)}
          >
            {zoom}
          </div>
        );
    });
  }

  renderModals() {
    return Object.keys(this.modals).map((key, index) => {
      const e = this.modals[key];
      return React.cloneElement(e, {
        key: index,
        ref: 'modal-' + key
      });
    });
  }

  showModal(name) {
    const ref = 'modal-' + name;
    const modal = this.refs[ref];
    if(modal) {
      modal.show();
    }
  }

  render() {
    return (
      <React.Fragment>
        <nav className="topNav">
          <ul className="left">
            <li>
              <NavButton
                id="file-btn"
                nav={this}
                className="menu-item"
                index="file"
              >
                File
              </NavButton>
            </li>
            <li>
              <button className="menu-item">Window</button>
            </li>
          </ul>
          <div className="zoomIndicator">
            <span ref="zoomify">
              {this.getZoomPercentage() + "%"}
              <svg width={16} height={16}>
                <polygon
                  points="0,6 8,14 16,6 8,10"
                  style={{ fill: "white", strokeWidth: 0 }}
                />
              </svg>
            </span>
            <div className="zooms" ref="zooms">
              {this.getAllZooms()}
            </div>
          </div>
          <ul className="right">
            <li>
              <button className="menu-item">About</button>
            </li>
          </ul>
          <div className="v-separator" />
          <div className="actions">
            <button className="btn export">
              <svg
                fill="white"
                width={14}
                height={16}
                style={{ paddingRight: 10, verticalAlign: "top" }}
              >
                <g>
                  <rect
                    x={0}
                    y={13}
                    width={14}
                    height={2}
                    fill="currentColor"
                  />
                  <rect x={5} y={6} width={4} height={5} fill="currentColor" />
                  <polygon points="0,6 14,6 7,0" fill="currentColor" />
                </g>
              </svg>
              Export
            </button>
            <button className="btn load">
              <svg
                fill="white"
                width={14}
                height={16}
                style={{ paddingRight: 10, verticalAlign: "top" }}
              >
                <g>
                  <rect x={0} y={0} width={14} height={2} fill="currentColor" />
                  <rect x={5} y={4} width={4} height={5} fill="currentColor" />
                  <polygon points="0,9 14,9 7,16" fill="currentColor" />
                </g>
              </svg>
              Load
            </button>
            <button className="btn save">Save</button>
          </div>
        </nav>
        <NavPane nav={this} ref="file-pane">
          <NavAction
            nav={this}
            action={() => {
              this.showModal('load-html');
            }}
            name="load-html"
          >
            Load HTML...
          </NavAction>
          <NavAction
            nav={this}
          >
            Yet another action
          </NavAction>
        </NavPane>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

export default TopNav;



// WEBPACK FOOTER //
// ./src/components/ui/TopNav.js